const defaultOptions = {
	controlsOptions: {
		library: false,
	},
	preferredRenderer: 'webgl',
	export: {
		type: 'data-url',
		download: false,
	},
	megapixels: 2,
	defaultControl: 'filter',
	forceCrop: false,
	assets: {
		baseUrl: '/bitrix/js/main/imageeditor/external/photoeditorsdk/assets',
	},
};

export default defaultOptions;